<div class="c-search ms-0 ms-md-4">
  <div class="input-group d-flex">
    <input
      type="text"
      [(ngModel)]="palabraClave"
      [ngModelOptions]="{ standalone: true }"
      class="form-control search-input border-0"
      placeholder="Buscar ..."
      (keyup.enter)="onBuscar()"
    />
    <button
      class="c-search-button input-group-text"
      type="button"
      (click)="filtros()?.palabraClave ? onLimpiarBusqueda() : onBuscar()"
    >
      <span class="material-symbols-rounded text-font">
        {{ filtros()?.palabraClave ? "close" : "search" }}
      </span>
    </button>
  </div>
</div>
